import requestService from '../services/requestService';
import BeEndpoints from '../../services/end-points/be-endpoints';
import { removeBlankKeys } from '../../components/material-ui/helper';

const getTransactionInfoController = (data, query) => {
  const { sourceRef } = query || {};
  const request = {
    method: 'post',
    url: BeEndpoints.TRANSACTION_DETAILS,
    data: removeBlankKeys(data),
    params: {
      srcRef: sourceRef,
    },
  };
  return requestService(query, request, (d) => d.data);
};

const initiateTxn = (data, query) => {
  const { sourceRef } = query || {};
  const request = {
    method: 'post',
    url: BeEndpoints.INITIATE_TXN,
    params: {
      srcRef: sourceRef,
    },
    data,
  };
  return requestService(query, request, (d) => d.data);
};

const confirmTransaction = (data, query) => {
  const { sourceRef } = query || {};
  const request = {
    method: 'post',
    url: BeEndpoints.CONFIRM_TRANSACTION,
    params: {
      srcRef: sourceRef,
    },
    data,
  };
  return requestService(query, request, (d) => d.data);
};

const resendTransactionOtp = (data, query) => {
  const request = {
    method: 'post',
    url: BeEndpoints.RESEND_TRANSACTION_OTP,
    data,
  };
  return requestService(query, request, (d) => d.data);
};

const postCancelTransaction = (data, query) => {
  const { sourceRef } = query || {};
  const request = {
    method: 'post',
    url: BeEndpoints.CANCEL_TRANSACTION,
    data,
    params: {
      srcRef: sourceRef,
    },
  };
  return requestService(query, request, (d) => d.data);
};

const postPosTxnSms = (data, query) => {
  const { sourceRef } = query || {};
  const request = {
    method: 'post',
    url: BeEndpoints.SEND_OFFLINE_TXN_SMS,
    data: removeBlankKeys(data),
    params: {
      srcRef: sourceRef,
    },
  };
  return requestService(query, request, (d) => d.data);
};

const getPosTxnStatus = (query) => {
  const { sourceRef, txnUuid } = query || {};
  const request = {
    method: 'get',
    url: BeEndpoints.GET_POS_TRANSACTION_STATUS,
    params: {
      srcRef: sourceRef,
      txnUuid: txnUuid,
    },
  };
  return requestService(query, request, (d) => d.data);
};

const getPosTxnDetails = (query) => {
  const { txnUuid, sourceRef } = query || {};
  const request = {
    method: 'get',
    url: BeEndpoints.GET_POS_TRANSACTION_DETAILS,
    params: {
      txnUuid: txnUuid,
      srcRef: sourceRef,
    },
  };
  return requestService(query, request, (d) => d.data);
};

const getTxnKfsData = (query, isTxnFlow) => {
  const { txnUuid, lenderId, emiTenure } = query || {};
  const request = {
    method: 'get',
    url: isTxnFlow
      ? BeEndpoints.CALCULATE_TXN_KFS_DATA
      : BeEndpoints.GET_TXN_KFS_DATA,
    params: {
      txnUuid: txnUuid,
      lenderId: lenderId,
      emiTenure: emiTenure,
    },
  };
  return requestService(query, request, (d) => d.data);
};

export const initiateInTxnLenderNTB = (data, query) => {
  const request = {
    method: 'post',
    url: `${BeEndpoints.IN_TRANSACTION_NTB_INITIATE_APPLICATION}`,
    data,
  };

  return requestService(query, request, (d) => d.data);
};

export const getInTxnNtbLenderStatus = (data, query) => {
  const request = {
    method: 'post',
    url: `${BeEndpoints.IN_TRANSACTION_NTB_LENDER_STATUS}`,
    data,
  };
  return requestService(query, request, (d) => d.data);
};

const confirmNtbTransaction = (query) => {
  const request = {
    method: 'post',
    url: BeEndpoints.CONFIRM_NTB_TRANSACTION,
  };
  return requestService(query, request, (d) => d.data);
};

export const GenericNtbPreEligibility = (data, query) => {
  const request = {
    method: 'post',
    url: BeEndpoints.GENERIC_NTB_PRE_ELIGIBILITY,
    data,
  };
  return requestService(query, request, (d) => d.data);
};

export const checkLenderNtbPreEligibilityInTxn = (data, query) => {
  const request = {
    method: 'post',
    url: `${BeEndpoints.IN_TRANSACTION_NTB_PRE_ELIGIBILITY}`,
    data,
  };

  return requestService(query, request, (d) => d.data);
};

export default {
  getTransactionInfoController,
  confirmTransaction,
  resendTransactionOtp,
  postCancelTransaction,
  postPosTxnSms,
  getPosTxnStatus,
  getPosTxnDetails,
  getTxnKfsData,
  confirmNtbTransaction,
  GenericNtbPreEligibility,
  initiateTxn,
};



// WEBPACK FOOTER //
// ./components/transaction/src/api/controllers/paymentController.js